import { GET_MOST_ENGAGED_VIDEOS_BY_TERRITORY, GET_VIDEOS_BY_TERRITORY } from './operations'
import type { PostsQueriesMap } from './types'

export const POSTS_QUERIES: PostsQueriesMap = {
  getMostEngagedVideosByTerritory: GET_MOST_ENGAGED_VIDEOS_BY_TERRITORY,
  getVideosByTerritory: GET_VIDEOS_BY_TERRITORY,
}
